import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, ObjectiveFlag, DBRadioButton } from '_components';
import styles from './Common.module.css'

class SpeechExpressiveLanguage extends React.Component {

    render() {
        return (
            <div>

                <div className={styles.formRowSetting}>
                <div className={styles.flgCol}>
                     <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} flagText='Expressive Language' />
                    </div>
                    <div className={styles.colHeader}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPSTATUS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPSTATUS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
                    </div>

                    <div className={styles.formRowSetting}>
                    <div className={styles.flgCol} />
                    <div className={styles.colHeader}>
                        Comments
                    </div>
                    </div>
                <div className={styles.formRowSetting}>
                <div className={styles.col} />
                <div className={styles.colRadio}>
                    <DBTextAreaObjective
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSEXPCOMMENTS'
                        className={styles.textarea}
                    />
                    </div>
                </div>

                <div className={styles.formRowSetting}>
                   <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.automaticsFlagged} flagText='Automatics' />
                   </div>

                   <div className={styles.colHeader}>
                   <b>Automatics</b>
                   </div>
                    
                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPAUTOMATICS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPAUTOMATICS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>

                <div className={styles.formRowSetting}>
                   <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.namingFlagged} flagText='Naming' />
                   </div>

                   <div className={styles.colHeader}>
                   <b>Naming</b>
                   </div>
                    
                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPNAMING'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPNAMING'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                    <div className={styles.flgCol} />
                    <div className={styles.colHeader}>
                       <b>Verbal Expression</b> 
                    </div>
                 </div>
        
                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.wordFlagged} flagText='Words' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Words
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPWORDS'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPWORDS'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>

                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                       <ObjectiveFlag className={styles.flag} flagged={this.props.phraseFlagged} flagText='Phrases' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Phrases
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPPHRASES'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPPHRASES'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                     <ObjectiveFlag className={styles.flag} flagged={this.props.sentenceFlagged} flagText='Sentences' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Sentences
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPSENTENCES'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPSENTENCES'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


                <div className={styles.formRowSetting}>
                <div className={styles.colInnerFlag}>
                         <ObjectiveFlag className={styles.flag} flagged={this.props.conversationFlagged} flagText='Conversation' />
                   </div>

                   <div className={styles.colInnerHeader}>
                       Conversation
                    </div>

                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPCONVERSATION'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPCONVERSATION'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>

                </div>


                <div className={styles.formRowSetting}>
                   <div className={styles.flgCol}>
                        <ObjectiveFlag className={styles.flag} flagged={this.props.writtenFlagged} flagText='Written Expression' />
                   </div>

                   <div className={styles.colHeader}>
                   <b>Written Expression</b>
                   </div>
                    
                   <div className={styles.colRadio}>
                            <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'WNL'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPWRITTEN'
                             entityKeyValue={this.props.osno}
                             label='WNL'
                             className={styles.radio}
                            />   
                    </div>   
                            
                    <div className={styles.colRadio}>

                             <DBRadioButton
                             noteId={this.props.noteId}
                             selectedValue={'Impaired'}
                             entityKeyColumn='OSNO'
                             entity='PTOBJECTIVESPEECH'
                             field= 'OSEXPWRITTEN'
                             entityKeyValue={this.props.osno}
                             label='Impaired'
                             className={styles.radio}
                            />   
                    </div>
 
                </div>


            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno,
        flagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPSTATUS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPSTATUS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPSTATUS !== 'WNL'),
        automaticsFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPAUTOMATICS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPAUTOMATICS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPAUTOMATICS !== 'WNL'),
        namingFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPNAMING !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPNAMING !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPNAMING !== 'WNL'),
        wordFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPWORDS !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPWORDS !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPWORDS !== 'WNL'),
        phraseFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPPHRASES !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPPHRASES !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPPHRASES !== 'WNL'),
        sentenceFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPSENTENCES !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPSENTENCES !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPSENTENCES !== 'WNL'),
        conversationFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPCONVERSATION !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPCONVERSATION !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPCONVERSATION !== 'WNL'),
        writtenFlagged: (state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPWRITTEN !== undefined 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPWRITTEN !== null 
            && state.entities.notes.PTOBJECTIVESPEECH[osno].OSEXPWRITTEN !== 'WNL')
    };
}

const connectedSpeechExpressiveLanguage = connect(mapStateToProps)(SpeechExpressiveLanguage);
export { connectedSpeechExpressiveLanguage as SpeechExpressiveLanguage };


